import list from './BulkAssistantList'export default list